module.exports = __webpack_public_path__ + "static/scapital_book-4d6da8524ba4c9778c4d081cf93c18c6.jpg";